import React from 'react';
import { css } from 'emotion';
import { text } from '@guardian/src-foundations/palette';
import { Zero } from '@root/src/web/components/numbers/Zero';
import { One } from '@root/src/web/components/numbers/One';
import { Two } from '@root/src/web/components/numbers/Two';
import { Three } from '@root/src/web/components/numbers/Three';
import { Four } from '@root/src/web/components/numbers/Four';
import { Five } from '@root/src/web/components/numbers/Five';
import { Six } from '@root/src/web/components/numbers/Six';
import { Seven } from '@root/src/web/components/numbers/Seven';
import { Eight } from '@root/src/web/components/numbers/Eight';
import { Nine } from '@root/src/web/components/numbers/Nine';
import { Ten } from '@root/src/web/components/numbers/Ten';
export const Score = ({ score }) => {
    const ScoreStyles = ({ children }) => (React.createElement("div", { className: css `
				position: relative;
				width: 3.75rem;
				height: 3.75rem;
				border-radius: 1.875rem;
				border: 0.0625rem solid ${text.primary};

				svg {
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					margin: auto;
				}
			` }, children));
    switch (score) {
        case 0:
            return (React.createElement(ScoreStyles, null,
                React.createElement(Zero, null)));
        case 1:
            return (React.createElement(ScoreStyles, null,
                React.createElement(One, null)));
        case 2:
            return (React.createElement(ScoreStyles, null,
                React.createElement(Two, null)));
        case 3:
            return (React.createElement(ScoreStyles, null,
                React.createElement(Three, null)));
        case 4:
            return (React.createElement(ScoreStyles, null,
                React.createElement(Four, null)));
        case 5:
            return (React.createElement(ScoreStyles, null,
                React.createElement(Five, null)));
        case 6:
            return (React.createElement(ScoreStyles, null,
                React.createElement(Six, null)));
        case 7:
            return (React.createElement(ScoreStyles, null,
                React.createElement(Seven, null)));
        case 8:
            return (React.createElement(ScoreStyles, null,
                React.createElement(Eight, null)));
        case 9:
            return (React.createElement(ScoreStyles, null,
                React.createElement(Nine, null)));
        case 10:
        default:
            return (React.createElement(ScoreStyles, null,
                React.createElement(Ten, null)));
    }
};
